// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Auction_main__OJLDO {
    display: flex;
    flex-direction: column;
    padding: 10px;
    font-family: Popins, sans-serif;
    color: white;
    gap: 20px;
    min-height: 100vh;

}

.Auction_wrapper__R8XHY {
    display: flex;
    gap: 10px;

}

.Auction_header__QEZss {
    display: flex;
    justify-content: center;
    font-size: 30px;
    margin-bottom: 10px;

}

.Auction_rules__sEXZT {
    display: flex;
    justify-content: space-between;
}

.Auction_rule__VLSFk {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    padding: 20px;
    color: white;
    font-size: 18px;
    max-width: 30%;
    font-family: Popins, sans-serif;
    background: linear-gradient(315deg, rgb(22 22 22 / 50%) 0%, rgb(43 43 43 / 66%) 100%);
    border-radius: 10px;
    border: 1px solid #ffffff1a;
}

.Auction_rule__VLSFk i {
    margin-left: 5px;
    margin-right: 5px;
}

.Auction_containerManager__mq61P {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    background-color: #242c544f;
    border-radius: 10px;
    position: relative;

}

.Auction_headBlock__fdMzJ {
    font-size: 20px;

}

.Auction_containerBet__U9t5Z {

    display: flex;
    order: 1;
    flex-direction: column;
    max-width: 500px;
    justify-content: left;
    padding: 10px;

    gap: 1rem;
    border-right: 1px solid #ffffff30;
    /* Добавляем красную линию справа */
}

.Auction_containerTime__9708F {
    margin-left: 15px;
    display: flex;
    order: 2;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 15px;
}

.Auction_infUsers__zi47W {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    width: 50%;
    border-radius: 10px;
}

.Auction_containerBetUser__qxAgj {
    display: flex;
    order: 3;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-right: 5%;
    /*border-right: 1px solid #ffffff30; /* Добавляем красную линию справа */

}

.Auction_infoBet__nztOy {
    padding: 20px;
    background: linear-gradient(315deg, rgb(8, 47, 3) 0%, rgba(132, 243, 165, 0.45) 100%);
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    text-align: center;
}

.Auction_infoBet__nztOy div {
    display: flex;
    justify-content: center;
}

.Auction_timeReg__UHqJY {
    color: #daf6ff;
    /*text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);*/

    letter-spacing: 0.05em;
    font-size: 40px;
    padding: 5px 0;
}

.Auction_blockHistoryButton__9idqk {
    position: absolute;
    top: 0;
    right: 0;
}

.Auction_line_block__ohONZ {
    background: #ffffff7a;
    height: 1px;
    width: 85%;
    margin: 10px 0;
}

.Auction_noHaveMebmers__Y5GrJ {
    padding: 5px;
    border: 1px solid #ff00008c;
    background: #ff000038;
    border-radius: 10px;
}

@media screen and (max-width:1000px) {
    .Auction_blockHistoryButton__9idqk {
        position: relative;

        top: 0;
        right: 0;
        display: flex;
        justify-content: flex-end;
    }
    .Auction_containerTime__9708F{
        padding-left: 0;
    }

    .Auction_containerBetUser__qxAgj {
        margin-right: 0;
    }

    .Auction_wrapper__R8XHY {
        flex-direction: column;
    }

    .Auction_infUsers__zi47W {
        width: 100% !important;
        max-height: 240px;
    }

    .Auction_rule__VLSFk {
        max-width: 100%;
        width: 100%;
        padding: 0;
        background: unset;
        border: unset;
        font-size: 16px;
    }

    .Auction_containerManager__mq61P {
        flex-direction: column;
    }

    .Auction_containerBet__U9t5Z {
        border-right: 0;
        /* Добавляем красную линию справа */
        border-bottom: 1px solid #ffffff30;
        /* Добавляем красную линию справа */


    }

    .Auction_main__OJLDO {
        margin-top: 60px;
    }

    .Auction_rules__sEXZT {
        flex-wrap: wrap;
        justify-content: center;
        background: linear-gradient(315deg, rgb(22 22 22 / 50%) 0%, rgb(43 43 43 / 66%) 100%);
        padding: 15px 10px;
        border: 1px solid #ffffff38;
        border-radius: 10px;
    }

    .Auction_line_block__ohONZ {
        background: #ffffff7a;
        height: 1px;
        width: 85%;
        margin: 10px 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Auction/Auction.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,+BAA+B;IAC/B,YAAY;IACZ,SAAS;IACT,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,SAAS;;AAEb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;IAElB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,cAAc;IACd,+BAA+B;IAC/B,qFAAqF;IACrF,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;;IAEI,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;;IAEb,SAAS;IACT,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,wEAAwE;;AAE5E;;AAEA;IACI,aAAa;IACb,qFAAqF;IACrF,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gFAAgF;;IAEhF,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;;QAElB,MAAM;QACN,QAAQ;QACR,aAAa;QACb,yBAAyB;IAC7B;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,mCAAmC;QACnC,kCAAkC;QAClC,mCAAmC;;;IAGvC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,qFAAqF;QACrF,kBAAkB;QAClB,2BAA2B;QAC3B,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,WAAW;QACX,UAAU;QACV,cAAc;IAClB;AACJ","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    padding: 10px;\n    font-family: Popins, sans-serif;\n    color: white;\n    gap: 20px;\n    min-height: 100vh;\n\n}\n\n.wrapper {\n    display: flex;\n    gap: 10px;\n\n}\n\n.header {\n    display: flex;\n    justify-content: center;\n    font-size: 30px;\n    margin-bottom: 10px;\n\n}\n\n.rules {\n    display: flex;\n    justify-content: space-between;\n}\n\n.rule {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    padding: 20px;\n    color: white;\n    font-size: 18px;\n    max-width: 30%;\n    font-family: Popins, sans-serif;\n    background: linear-gradient(315deg, rgb(22 22 22 / 50%) 0%, rgb(43 43 43 / 66%) 100%);\n    border-radius: 10px;\n    border: 1px solid #ffffff1a;\n}\n\n.rule i {\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n.containerManager {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 10px;\n    background-color: #242c544f;\n    border-radius: 10px;\n    position: relative;\n\n}\n\n.headBlock {\n    font-size: 20px;\n\n}\n\n.containerBet {\n\n    display: flex;\n    order: 1;\n    flex-direction: column;\n    max-width: 500px;\n    justify-content: left;\n    padding: 10px;\n\n    gap: 1rem;\n    border-right: 1px solid #ffffff30;\n    /* Добавляем красную линию справа */\n}\n\n.containerTime {\n    margin-left: 15px;\n    display: flex;\n    order: 2;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 15px;\n}\n\n.infUsers {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n    width: 50%;\n    border-radius: 10px;\n}\n\n.containerBetUser {\n    display: flex;\n    order: 3;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    margin-right: 5%;\n    /*border-right: 1px solid #ffffff30; /* Добавляем красную линию справа */\n\n}\n\n.infoBet {\n    padding: 20px;\n    background: linear-gradient(315deg, rgb(8, 47, 3) 0%, rgba(132, 243, 165, 0.45) 100%);\n    border-radius: 10px;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    text-align: center;\n}\n\n.infoBet div {\n    display: flex;\n    justify-content: center;\n}\n\n.timeReg {\n    color: #daf6ff;\n    /*text-shadow: 0 0 20px rgba(10, 175, 230, 1),  0 0 20px rgba(10, 175, 230, 0);*/\n\n    letter-spacing: 0.05em;\n    font-size: 40px;\n    padding: 5px 0;\n}\n\n.blockHistoryButton {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n.line_block {\n    background: #ffffff7a;\n    height: 1px;\n    width: 85%;\n    margin: 10px 0;\n}\n\n.noHaveMebmers {\n    padding: 5px;\n    border: 1px solid #ff00008c;\n    background: #ff000038;\n    border-radius: 10px;\n}\n\n@media screen and (max-width:1000px) {\n    .blockHistoryButton {\n        position: relative;\n\n        top: 0;\n        right: 0;\n        display: flex;\n        justify-content: flex-end;\n    }\n    .containerTime{\n        padding-left: 0;\n    }\n\n    .containerBetUser {\n        margin-right: 0;\n    }\n\n    .wrapper {\n        flex-direction: column;\n    }\n\n    .infUsers {\n        width: 100% !important;\n        max-height: 240px;\n    }\n\n    .rule {\n        max-width: 100%;\n        width: 100%;\n        padding: 0;\n        background: unset;\n        border: unset;\n        font-size: 16px;\n    }\n\n    .containerManager {\n        flex-direction: column;\n    }\n\n    .containerBet {\n        border-right: 0;\n        /* Добавляем красную линию справа */\n        border-bottom: 1px solid #ffffff30;\n        /* Добавляем красную линию справа */\n\n\n    }\n\n    .main {\n        margin-top: 60px;\n    }\n\n    .rules {\n        flex-wrap: wrap;\n        justify-content: center;\n        background: linear-gradient(315deg, rgb(22 22 22 / 50%) 0%, rgb(43 43 43 / 66%) 100%);\n        padding: 15px 10px;\n        border: 1px solid #ffffff38;\n        border-radius: 10px;\n    }\n\n    .line_block {\n        background: #ffffff7a;\n        height: 1px;\n        width: 85%;\n        margin: 10px 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Auction_main__OJLDO`,
	"wrapper": `Auction_wrapper__R8XHY`,
	"header": `Auction_header__QEZss`,
	"rules": `Auction_rules__sEXZT`,
	"rule": `Auction_rule__VLSFk`,
	"containerManager": `Auction_containerManager__mq61P`,
	"headBlock": `Auction_headBlock__fdMzJ`,
	"containerBet": `Auction_containerBet__U9t5Z`,
	"containerTime": `Auction_containerTime__9708F`,
	"infUsers": `Auction_infUsers__zi47W`,
	"containerBetUser": `Auction_containerBetUser__qxAgj`,
	"infoBet": `Auction_infoBet__nztOy`,
	"timeReg": `Auction_timeReg__UHqJY`,
	"blockHistoryButton": `Auction_blockHistoryButton__9idqk`,
	"line_block": `Auction_line_block__ohONZ`,
	"noHaveMebmers": `Auction_noHaveMebmers__Y5GrJ`
};
export default ___CSS_LOADER_EXPORT___;
